
import { useDispatch, useSelector } from "react-redux";
import { Box, Checkbox, TextField, Tooltip } from "@mui/material";
import MaterialTable from "material-table"
import AddIcon from '@mui/icons-material/Add';
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from '@mui/icons-material/Delete';
import { AddWorkHoursAction, DeleteWorkHoursAction, UpdateWorkHoursAction } from "../../../../../store/Leave/WeekOff/Action";
import { LabelWithInfo } from "../../../Base/views/LabelwithInfo";
const WorkingHours = () => {
    const dispatch = useDispatch()
    const { work_hours_data } = useSelector(state => state.LeaveReducer?.WeekOffConfigureReducer);

    return (
        <Box>
            <MaterialTable
                columns={[
                    {
                        title: "Work Hour Code", 
                        field: "work_hour_code",
                        editComponent: props => {
                            return (
                            <TextField
                                required={true}
                                variant="standard"
                                disabled
                                value={props?.value}
                                onChange={e => props.onChange(e.target.value)}
                            />
                        )}
                    },
                    {
                        title: "Work Hour", field: "working_hours", 
                        validate: (rowData) => {
                            if (rowData?.tableData && rowData?.tableData?.editing === "delete") {
                                return ""; 
                            }
                            if (!rowData?.working_hours?.trim()) {
                                return "Title cannot be empty";
                            }

                            return "";
                        },
                        editComponent: props => {
                            const isEdit = props.rowData?.tableData?.editing === "update";
                            return (
                            <TextField
                                required={true}
                                variant="standard"
                                value={props?.value}
                                onChange={e => props.onChange(e.target.value)}
                                disabled={isEdit}
                            />
                        )}
                    },
                    {
                    title: <LabelWithInfo variant="body2" style={{fontWeight: 600}} label={"Default for Full-Time Employees"} tooltip={"When enabled, this Work Hour will be automatically assigned to newly added Full-Time employees."} />,
                    field: "fte_default",
                    align: "center",
                    render: (rowData) => (rowData?.fte_default ? "Yes" : "No"),
                    editComponent: (props) => {
                        const notAllowed = props.rowData?.fte_default;
                        return (
                            <Box display={"flex"} justifyContent={"center"}>
                                <Checkbox
                                    checked={Boolean(props?.value)}
                                    onChange={(e) => props.onChange(e.target.checked)}
                                    inputProps={{ "aria-label": "Taxable Checkbox" }}
                                    disabled={notAllowed}
                                />
                            </Box>
                    )},
                    },
                    {
                    title: <LabelWithInfo variant="body2" style={{fontWeight: 600}}  label={"Default for Contractual Employees"} tooltip={"When enabled, this Work Hour will be automatically assigned to newly added Contractual employees."} />,
                    field: "contractual_default",
                    align: "center",
                    render: (rowData) => (rowData?.contractual_default ? "Yes" : "No"),
                    editComponent: (props) => {
                        const notAllowed = props.rowData?.contractual_default;
                        return (
                            <Box display={"flex"} justifyContent={"center"}>
                                <Checkbox
                                    checked={Boolean(props?.value)}
                                    onChange={(e) => props.onChange(e.target.checked)}
                                    inputProps={{ "aria-label": "ESIC Checkbox" }}
                                    disabled={notAllowed}
                                />
                            </Box>
                    )},
                    },
                ]}
                data={work_hours_data || []}
                components={{
                    Container: props => (
                      <div style={{ backgroundColor: "f3edfd" }}>
                        {props.children}
                      </div>
                    ),
                  }}
                icons={{
                    Add: () => <AddIcon />,
                    Edit: (props) => <EditIcon sx={{ color: props?.disabled ? "#bdbdbd" : "#637381"}}/>,
                    Delete: (props) => <DeleteIcon sx={{ color: props?.disabled ? "#bdbdbd" : "#637381"}} />
                }}
                editable={{
                    isEditable: (rowData) => !(rowData?.fte_default && rowData?.contractual_default),
                    isDeletable: rowData => !rowData?.fte_default && !rowData?.contractual_default,
                    onRowAdd: (newRow) =>
                        new Promise((resolve, reject) => {
                             if (!newRow?.working_hours?.trim()) {
                                return reject();
                            }
                            dispatch(AddWorkHoursAction(newRow))
                            setTimeout(() => resolve(), 500);
                        }),
                    onRowUpdate: (newRow, oldRow) =>
                        new Promise((resolve, reject) => {
                            if (!newRow?.working_hours?.trim()) {
                                return reject();
                            }
                            dispatch(UpdateWorkHoursAction(newRow))
                            setTimeout(() => resolve(), 500);
                        }),
                    onRowDelete: (selectedRow) =>
                        new Promise((resolve, reject) => {
                            dispatch(DeleteWorkHoursAction({ work_hour_configuration_id: selectedRow?.work_hour_configuration_pk }))
                            setTimeout(() => resolve(), 1000);
                        }),
                }}
                options={{
                    maxBodyHeight: 220,
                    rowStyle: { fontSize: "13px" },
                    headerStyle: { padding: "5px 10px", fontWeight: "bold" },
                    cellStyle: { padding: "5px 5px 5px 13px" },
                    sorting: true,
                    search: false,
                    searchFieldAlignment: "right",
                    searchAutoFocus: true,
                    searchFieldVariant: "standard",
                    filtering: false,
                    paging: false,
                    selection: false,
                    actionsColumnIndex: -1,
                    grouping: false,
                    addRowPosition: "first",
                }}
                title=""

            />
        </Box>
    );
}
export default WorkingHours;